import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getGeneralInformationInitialValues } from './utils';

import type { RootState } from '../../../../../../../store';

export default function useGeneralInformationInitialValues() {
  const generalInfo = useSelector(
    (state: RootState) =>
      state.onboardingQuestionnaire.onboardingQuestionnaireDetails?.general_info,
  );

  return useMemo(() => getGeneralInformationInitialValues(generalInfo), [generalInfo]);
}
